import { FoodsIconButton } from "@foodpilot/foods";
import { Box, useTheme } from "@mui/material";

type LeverIndicatorDetailsButtonProps = {
    label: string;
    onClick?: () => void;
};

export const LeverIndicatorDetailsButton = (props: LeverIndicatorDetailsButtonProps) => {
    const { label, onClick } = props;
    const theme = useTheme();

    return (
        <Box
            sx={{
                position: "absolute",
                right: theme.spacing(2.5),
                top: theme.spacing(2.5),
            }}
        >
            <FoodsIconButton
                icon="information"
                size="s"
                withBackground
                buttonProps={{
                    "aria-label": label,
                    onClick,
                    type: "button",
                }}
                tooltip={{
                    text: label,
                }}
            />
        </Box>
    );
};
